.orange {
    color: var(--hps-dark-orange);
}

.red {
    color: var(--hps-red);
}

.markerRow {
    display: flex;
    align-items: center;
    gap: 6px;
}